import {
    default_epp,
    default_params,
    default_worker,
    default_worker_epp_fit_test,
    default_worker_exam,
    default_worker_group_epp,
    default_worker_position,
    default_worker_training,
} from "./state";
const moment = require("moment");

/**
 * Establecer un valor para la variable workers.
 */
export function setWorkers(state, workers) {
    state.workers = workers;
}

/**
 * Establecer un valor para la variable worker.
 */
export function setWorker(state, worker) {
    worker.epps = [];
    state.worker = worker;
    worker.position = {
        start_date: moment().format("YYYY-MM-DD"),
        wor_position_id: worker.wor_worker_current_position
            ? worker.wor_worker_current_position.wor_position_id
            : null,
    };
}

/**
 * Establecer un valor para la variable worker.
 */
export function setTrainings(state, trainings) {
    state.trainings = trainings;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditingPosition(state, editing_position) {
    state.editing_position = editing_position;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditingEpp(state, editing_epp) {
    state.editing_epp = editing_epp;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditingExam(state, editing_exam) {
    state.editing_exam = editing_exam;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditingExamEdit(state, editing_exam_edit) {
    state.editing_exam_edit = editing_exam_edit;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditingTraining(state, editing_training) {
    state.editing_training = editing_training;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.workers = { data: [] };
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_Position.
 */
export function setModalPositionShow(state, show) {
    state.modal_position.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_training.
 */
export function setModalTrainingShow(state, show) {
    state.modal_training.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_epp.
 */
export function setModalEppShow(state, show) {
    state.modal_epp.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_fit_epp.
 */
export function setModalFitEppShow(state, show) {
    state.modal_fit_epp.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_edit_epp.
 */
export function setModalEditEppShow(state, show) {
    state.modal_edit_epp.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_edit_exam.
 */
export function setModalEditExamShow(state, show) {
    state.modal_edit_exam.show = show;
}

/**
 * Establecer un valor para el atributo show la variable modal_exam.
 */
export function setModalExamShow(state, show) {
    state.modal_exam.show = show;
}

/**
 * Establecer el valor por defecto de worker.
 */
export function resetWorker(state) {
    state.worker = default_worker();
}

/**
 * Establecer el valor por defecto de worker_position.
 */
export function resetWorkerPosition(state, start_date) {
    state.worker_position = default_worker_position();
    state.worker_position.start_date = start_date;
}

/**
 * Establecer el valor por defecto de worker_exam.
 */
export function resetWorkerExam(state, date) {
    state.worker_exam = default_worker_exam();
    state.worker_exam.date = date;
}

/**
 * Establecer el valor por defecto de worker_position.
 */
export function resetWorkerTraining(state) {
    state.worker_training = default_worker_training();
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Establecer el valor por defecto de areas.
 */
export function setAreas(state, areas) {
    state.areas = areas;
}

/**
 * Establecer el valor por defecto de positions.
 */
export function setPositions(state, positions) {
    state.positions = positions;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para la variable types_epp.
 */
export function setTypesEpp(state, types_epp) {
    state.types_epp = types_epp;
}

/**
 * Establecer el valor por defecto de worker_positions.
 */
export function setWorkerPositions(state, worker_positions) {
    state.worker_positions = worker_positions;
}

/**
 * Establecer el valor por defecto de worker_exams.
 */
export function setWorkerGroupExam(state, worker_group_exam) {
    /*worker_group_exam.exams = [];

    worker_group_exam.wor_worker_exams.map((exam) => {
    worker_group_exam.exams.push(exam.sys_list_exam_id)
    })*/

    state.worker_group_exam = worker_group_exam;
}

/**
 * Establecer el valor por defecto de worker_trainings.
 */
export function setWorkerTrainings(state, worker_trainings) {
    state.worker_trainings = worker_trainings;
}

/**
 * Establecer un valor para la variable worker_training.
 */
export function setWorkerTraining(state, worker_training) {
    state.worker_training = worker_training;
}

/**
 * Establecer el valor por defecto de worker_position.
 */
export function setWorkerPosition(state, worker_position) {
    state.worker_position = worker_position;
}

/**
 * Establecer el valor por defecto de worker_positions.
 */
export function setPositionEpps(state, position_epps) {
    state.position_epps = position_epps;
}

/**
 * Establecer un valor para la variable epps.
 */
export function setEpps(state, epps) {
    state.epps = epps;
}

/**
 * Establecer el valor por defecto de epp.
 */
export function resetEpp(state) {
    state.epp = default_epp();
}

/**
 * Establecer el valor por defecto de worker_epp
 */
export function setEppsWorkerEpps(state) {
    let epps = [];
    state.position_epps.map((epp) => {
        epps.push(epp.wor_epp_id);
    });

    state.worker_epp.epps = epps;
}

/**
 * Establecer el valor por defecto de worker_epps.
 */
export function setWorkerEpps(state, worker_epps) {
    state.worker_epps = worker_epps;
}

/**
 * Establecer el valor por defecto de worker_epp.
 */
export function setWorkerFitTestEpp(state, worker_fit_test_epp) {
    state.worker_fit_test_epp = worker_fit_test_epp;
}

/**
 * Establecer el valor por defecto de worker_fit_epps
 */
export function setWorkerFitEpps(state, worker_fit_epps) {
    state.worker_fit_epps = worker_fit_epps;
}

/**
 * Establecer el valor por defecto de worker_group_epp.
 */
export function setWorkerGroupEpp(state, worker_group_epp) {
    state.worker_group_epp = worker_group_epp;
}

/**
 * Establecer un valor para la variable exams.
 */
export function setExams(state, exams) {
    state.exams = exams;
}

/**
 * Establecer el valor por defecto de worker_exam_edit.
 */
export function setWorkerExam(state, worker_exam) {
    let exams = [];

    worker_exam.wor_worker_exams.map((e) => {
        exams.push(e.sys_list_exam_id);
    });

    worker_exam.exams = exams;

    state.worker_exam = worker_exam;
}

/**
 * Establecer un valor para la variable worker_fit_epp.
 */
export function setWorkerFitEpp(state, worker_fit_epp) {
    state.worker_fit_epp = worker_fit_epp;
}

/**
 * Establecer un valor para la variable worker_group_epp.
 */
export function resetWorkerGroupEpp(state, position_epps = []) {
    state.worker_group_epp = default_worker_group_epp();

    position_epps.map((pe) => {
        state.worker_group_epp.epps.push(pe.form_submission_id);
    });
}

/**
 * Establecer un valor para la variable worker_epp.
 */
export function setWorkerEpp(state, worker_epp) {
    state.worker_epp = worker_epp;
}

/**
 * Establecer un valor para la variable editing_fit_epp.
 */
export function setEditingFitEpp(state, editing_fit_epp) {
    state.editing_fit_epp = editing_fit_epp;
}

/**
 * Establecer un valor para el atributo show de la variable modal_group_epp.
 */
export function setShowToModalGroupEpp(state, show) {
    state.modal_group_epp.show = show;
}

/**
 * Establecer un valor para la variable editing_group_epp.
 */
export function setEditingGroupEpp(state, editing_group_epp) {
    state.editing_group_epp = editing_group_epp;
}

/**
 * Establecer un valor para la variable worker_groups_epps.
 */
export function setWorkerGroupsEpps(state, worker_groups_epps) {
    state.worker_groups_epps = worker_groups_epps;
}

/**
 * Establecer un valor para el atributo show de la variable modal_worker_epp.
 */
export function setShowToModalWorkerEpp(state, show) {
    state.modal_worker_epp.show = show;
}

/**
 * Establecer un valor para la variable editing_worker_epp_fit_test.
 */
export function setEditingWorkerEppFitTest(state, editing_worker_epp_fit_test) {
    state.editing_worker_epp_fit_test = editing_worker_epp_fit_test;
}

/**
 * Establecer un valor para el atributo show de la variable modal_worker_epp_fit_test.
 */
export function setShowToModalWorkerEppFitTest(state, show) {
    state.modal_worker_epp_fit_test.show = show;
}

/**
 * Establecer un valor para la variable worker_fit_epp.
 */
export function resetWorkerEppFitTest(state) {
    state.worker_epp_fit_test = default_worker_epp_fit_test();
}

/**
 * Establecer un valor para la variable worker_epp_fit_test.
 */
export function setWorkerEppFitTest(state, worker_epp_fit_test) {
    state.worker_epp_fit_test = worker_epp_fit_test;
}

/**
 * Establecer un valor para el atributo show de la variable modal_upload.
 */
export function setShowToModalUpload(state, show) {
    state.upload = { file: null };
    state.modal_upload.show = show;
}

/**
 * Establecer nombres del responsable para modal de trabajadores
 */
export function setNamesWorker(state, name) {
    const parts = name.split(" ");
    if (!parts.length) return;
    let index = 1;
    if (parts.length == 1) {
        index = -1;
    } else if (parts.length == 4) {
        index = 2;
    } else if (parts.length >= 5) {
        index = 3;
    }
    const names = parts.slice(0, parts.length - index).join(" ");
    const surnames = parts.slice(-index).join(" ");

    state.worker.names = names;
    state.worker.surnames = surnames;
}

/**
 * Establecer la ubicación asociada al trabajador.
 */
export function setLocationtoWorker(state, slq_location_id) {
    state.worker.slq_location_id = slq_location_id;
}


/**
 * Establecer la ubicación actual de un cargo.
 */
export function setCurrentSlqLocationId(state, slq_location_id) {
    state.current_slq_location_id = slq_location_id;
}
